import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { PrimaAutenticazioneGuard } from './core/auth/prima-autenticazione.guard';
import { onboardingStartupGuard } from './core/auth/onboarding-startup.guard';

const routes: Routes = [
  // ROOT: solo redirect "muto", NESSUNA GUARD qui
  { path: '', pathMatch: 'full', redirectTo: 'primo-accesso' },

  // LOGIN (lazy module o standalone, come già hai)
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
  },

  // PRIMO ACCESSO — QUI metti la guard
  {
    path: 'primo-accesso',
    canMatch: [onboardingStartupGuard],
    loadChildren: () =>
      import('./pages/primo-accesso/primo-accesso.module')
        .then(m => m.PrimoAccessoPageModule),
  },

  // PRIMA AUTENTICAZIONE (protetta)
  {
    path: 'prima-autenticazione',
    canActivate: [PrimaAutenticazioneGuard],
    loadChildren: () =>
      import('./pages/prima-autenticazione/prima-autenticazione.module')
        .then(m => m.PrimaAutenticazionePageModule),
  },

  // MAIN protetto
  {
    path: 'main',
    canActivate: [AuthGuard],
    loadChildren: () => import('./main/main.module').then(m => m.MainPageModule),
  },

  // ALTRE FEATURE ROUTES (come le avevi)
  { path: 'impianti', loadChildren: () => import('./pages/plants/plants.module').then(m => m.PlantsModule) },
  { path: 'sos', loadChildren: () => import('./pages/sos/sos.module').then(m => m.SosModule) },
  { path: 'devicelist', loadChildren: () => import('./pages/devicelist/devicelist.module').then(m => m.DevicelistModule) },
  { path: 'selectdevices', loadChildren: () => import('./pages/selectdevices/selectdevices.module').then(m => m.SelectdevicesModule) },
  { path: 'sendalert', loadChildren: () => import('./pages/sendalert/sendalert.module').then(m => m.SendalertlistModule) },
  { path: 'alertresponse', loadChildren: () => import('./pages/alertresponse/alertresponse.module').then(m => m.AlertresponseModule) },
  { path: 'dateproposal', loadChildren: () => import('./pages/dateproposal/dateproposal.module').then(m => m.DateproposalModule) },
  { path: 'confirmeddate', loadChildren: () => import('./pages/confirmeddate/confirmeddate.module').then(m => m.ConfirmedDateModule) },
  { path: 'appointment', loadChildren: () => import('./pages/appointment/appointment.module').then(m => m.AppointmentModule) },
  { path: 'paymantlist', loadChildren: () => import('./pages/paymentlist/paymentlist.module').then(m => m.PaymentlistModule) },
  { path: 'actionfeedback', loadChildren: () => import('./pages/actionfeedback/actionfeedback.module').then(m => m.ActionFeedbackModule) },
  { path: 'actionfeedback/:id', loadChildren: () => import('./pages/actionfeedback/actionfeedback.module').then(m => m.ActionFeedbackModule) },
  { path: 'actionlist', loadChildren: () => import('./pages/actionlist/actionlist.module').then(m => m.ActionlistModule) },
  { path: 'activityselected', loadChildren: () => import('./pages/activityselected/activityselected.module').then(m => m.ActivityselectedModule) },
  { path: 'activityselected/:id', loadChildren: () => import('./pages/activityselected/activityselected.module').then(m => m.ActivityselectedModule) },
  { path: 'notifications', loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificatiosModule) },
  { path: 'promo', loadChildren: () => import('./pages/notificationspromo/notificationspromo.module').then(m => m.NotificationpromoModule) },

  // Wildcard sempre in fondo
  { path: '**', redirectTo: 'primo-accesso' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    initialNavigation: 'enabledBlocking',
    enableTracing: true, // ok per debug
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
